// extracted by mini-css-extract-plugin
export default {"box":"ShipmentDestination_box__bjxFO","header":"ShipmentDestination_header__e+xoD","source":"ShipmentDestination_source__sskWU"};